import { useState, useEffect } from 'react';
import classNames from 'classnames';

const Text = props => {
    const [value, setValue] = useState('');
    const [debounceTimeout, setDebounceTimeout] = useState(null);
    const { context, debounceTime = 1000 } = props;

    const handleChange = e => {
        if (debounceTimeout) {
            clearTimeout(debounceTimeout);
        }

        const newValue = e.target.value;
        setValue(newValue);

        setDebounceTimeout(
            setTimeout(() => {
                context.setFilterValue(props.name, newValue);
            }, debounceTime)
        );
    };

    const handleClear = () => {
        setValue('');
        context.setFilterValue(props.name, null);
    };

    useEffect(() => {
        if (props.value != value && props.value) {
            setValue(props.value);
        }
    }, [props.value]);

    const styles = {
        paddingRight: '20px',
        ...props.inputStyles
    };

    return (
        <div className={classNames('searchable-list-button-search')}>
            <div
                style={{
                    position: 'relative'
                }}
            >
                <label htmlFor={`search-filter-${props.name}`} className="sr-only">
                    Search
                </label>
                <input
                    type="text"
                    name={props.name}
                    id={`search-filter-${props.name}`}
                    placeholder={props.label}
                    title={props.label}
                    value={value}
                    style={styles}
                    onChange={handleChange}
                />
                <div
                    style={{
                        position: 'absolute',
                        right: '5px',
                        top: '3px'
                    }}
                >
                    {value && value.length > 0 ? (
                        <span className="text-danger" onClick={handleClear}>
                            <i className="fal fa-times">
                                <span className="sr-only">Clear</span>
                            </i>
                        </span>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default Text;
